export class ApiResponse {
    constructor(code, message, data, pagination) {
        this.code = code;
        this.message = message;
        this.data = data;
        this.pagination = pagination;
    }
}
